import Head from "next/head";
import PortalsPage from "../../src/info/RegionsPage.tsx";

export default function PortalsInfo({ portals }) {
  return (
    <>
      <Head>
        <title>TFT Set 18 Encounters Info</title>
      </Head>
      <PortalsPage portals={portals} />
    </>
  );
}

//
export async function getStaticProps({ locale }) {
  const portalsResp = await fetch(
    `https://ap.tft.tools/static/s18/portals_${locale}.json`,
  );
  const portals = await portalsResp.json();

  return {
    props: {
      portals,
    },
    revalidate: 3600,
  };
}
